import { CollateralEntity } from '@evidentid/tprm-portal-lib/models/entity-details/Collateral/CollateralEntity.model';
import { CollateralMappingType } from '@evidentid/tprm-portal-lib/models/entity-details/Collateral/CollateralMappingType.model';

export function isCollateralMappingHasNoMatch(collateralEntity: CollateralEntity): boolean {
    return collateralEntity.mapping?.mappingType === CollateralMappingType.manual &&
        collateralEntity.mapping.collateral === null;
}
